export { NewsletterCta } from '@/components/product/newsletter-cta'
export { ProductDetail } from '@/components/product/product-detail'
export { ProductGallery } from '@/components/product/product-gallery'
export { ReviewsSlider } from '@/components/product/reviews-slider'
